import styled from 'styled-components'

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const Link = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  color: ${props => props.theme.colors.info.onSurface};
  font-family: ${props => props.theme.texts.bodySRegular.fontFamily};
  font-size: ${props => props.theme.texts.bodySRegular.fontSize};
  text-decoration: underline;
  cursor: pointer;
`
